// import privateAxiosInstance from "../utils/axios/private";

// const BASE_URL = "/jd-gen";

// export const jdGeneratorApi = {
//     startSession: async (userId, prompt) => {
//         // console.log("🚀 Starting Session for User:", userId, "with prompt:", prompt);
//         // console.log("URL:", `${BASE_URL}/session/start/`);
//         try {
//             const response = await privateAxiosInstance.post(`${BASE_URL}/session/start/`, {
//                 user_id: userId,
//                 prompt,
//             });
//             // console.log("✅ Session Started Successfully:", response.data);
//             return response.data;

//         } catch (error) {
//             if (error.code === "ERR_NETWORK") return { status: 0, message: "Network error." };
//             return error.response?.data;
//         }
//     },

//     submitClarification: async (sessionId, answers) => {
//         try {
//             const response = await privateAxiosInstance.post(`${BASE_URL}/session/clarify/`, {
//                 session_id: sessionId,
//                 answers,
//             });
//             return response.data;
//         } catch (error) {
//             if (error.code === "ERR_NETWORK") return { status: 0, message: "Network error." };
//             return error.response?.data;
//         }
//     },

//     generateDirect: async (sessionId) => {
//         try {
//             // MATCHES DJANGO: path("session/generate/", ...)
//             const response = await privateAxiosInstance.post(`${BASE_URL}/session/generate/`, {
//                 session_id: sessionId,
//             });
//             return response.data;
//         } catch (error) {
//             if (error.code === "ERR_NETWORK") return { status: 0, message: "Network error." };
//             return error.response?.data;
//         }
//     },

//     refineJD: async (sessionId, feedback) => {
//         try {
//             // MATCHES DJANGO: path("session/refine/", ...)
//             const response = await privateAxiosInstance.post(`${BASE_URL}/session/refine/`, {
//                 session_id: sessionId,
//                 instruction: feedback,
//             });
//             return response.data;
//         } catch (error) {
//             if (error.code === "ERR_NETWORK") return { status: 0, message: "Network error." };
//             return error.response?.data;
//         }
//     },

//     finalizeJD: async (sessionId) => {
//         try {
//             // MATCHES DJANGO: path("session/finalize/", ...)
//             const response = await privateAxiosInstance.post(`${BASE_URL}/session/finalize/`, {
//                 session_id: sessionId,
//             });
//             return response.data;
//         } catch (error) {
//             if (error.code === "ERR_NETWORK") return { status: 0, message: "Network error." };
//             return error.response?.data;
//         }
//     },
// };







import privateAxiosInstance from "../utils/axios/private";
import { hybridDecrypt } from "../utils/crypto";

const BASE_URL = "/jd-gen";

export const jdGeneratorApi = {
    async startSession(userId, prompt) {
        try {
            const response = await privateAxiosInstance.post(
                `${BASE_URL}/session/start/`,
                {
                    user_id: userId,
                    prompt,
                }
            );

            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }

            return response.data;
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection.",
                    type: "network_error",
                };
            }

            return error.response?.data || {
                status: 500,
                message: "Error starting JD generation session",
            };
        }
    },

    async submitClarification(sessionId, answers) {
        try {
            const response = await privateAxiosInstance.post(
                `${BASE_URL}/session/clarify/`,
                {
                    session_id: sessionId,
                    answers,
                }
            );

            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }

            return response.data;
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection.",
                    type: "network_error",
                };
            }

            return error.response?.data || {
                status: 500,
                message: "Error submitting clarification",
            };
        }
    },

    async generateDirect(sessionId) {
        try {
            const response = await privateAxiosInstance.post(
                `${BASE_URL}/session/generate/`,
                {
                    session_id: sessionId,
                }
            );

            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }

            return response.data;
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection.",
                    type: "network_error",
                };
            }

            return error.response?.data || {
                status: 500,
                message: "Error generating JD",
            };
        }
    },

    async refineJD(sessionId, feedback) {
        try {
            const response = await privateAxiosInstance.post(
                `${BASE_URL}/session/refine/`,
                {
                    session_id: sessionId,
                    instruction: feedback,
                }
            );

            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }

            return response.data;
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection.",
                    type: "network_error",
                };
            }

            return error.response?.data || {
                status: 500,
                message: "Error refining JD",
            };
        }
    },

    async finalizeJD(sessionId) {
        try {
            const response = await privateAxiosInstance.post(
                `${BASE_URL}/session/finalize/`,
                {
                    session_id: sessionId,
                }
            );

            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }

            return response.data;
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection.",
                    type: "network_error",
                };
            }

            return error.response?.data || {
                status: 500,
                message: "Error finalizing JD",
            };
        }
    },
};
